export default __webpack_public_path__ + "static/media/actionPost.cf42873a.svg";